// 根据环境引入不同配置 process.env.NODE_ENV
const isSN_ENV = (process.env.SN_ENV || 'DEV').trim().toLowerCase();
const _protocol_ = location.protocol;

const AUTH_HOST = {
	PRD: _protocol_ + '//sums.suning.com',
	PRE: _protocol_ + '//sumspre.cnsuning.com',
	SIT: _protocol_ + '//sumssit.cnsuning.com',
	DEV: _protocol_ + '//devspre.cnsuning.com',
	XGPRE: _protocol_ + '//sumsprexg.cnsuning.com',
};

const SUMFS_HOST = {
	PRD: _protocol_ + '//sumfs.suning.com',
	PRE: _protocol_ + '//sumfspre.cnsuning.com',
	XGPRE: _protocol_ + '//sumfsprexg.cnsuning.com',
	SIT: _protocol_ + '//sumfssit.cnsuning.com',
	DEV: _protocol_ + '//sumfspre.cnsuning.com',
};

const SUMIS_HOST = {
	PRD: _protocol_ + '//sumis.suning.com',
	PRE: _protocol_ + '//sumispre.cnsuning.com',
	XGPRE: _protocol_ + '//sumisprexg.cnsuning.com',
	SIT: _protocol_ + '//sumissit.cnsuning.com',
	DEV: _protocol_ + '//sumispre.cnsuning.com',
};

const PASSPORT_HOST = {
	PRD: 'https://passport.suning.com/ids',
	PRE: 'https://passportpre.cnsuning.com/ids',
	XGPRE: 'http://passportprexg.cnsuning.com/ids',
	SIT: 'http://passportsit.cnsuning.com/ids',
	DEV: 'https://passportpre.cnsuning.com/ids',
};

const ADRES_HOST = {
	// 公共静态资源地址
	DEV: _protocol_ + '//adressit.cnsuning.com',
	SIT: _protocol_ + '//adressit.cnsuning.com',
	PRE: _protocol_ + '//adrespre.cnsuning.com',
	XGPRE: _protocol_ + '//adresxgpre.cnsuning.com',
	PRD: _protocol_ + '//adres.suning.com',
};

const SUCS_HOST = {
	PRD: _protocol_ + '//sucs.suning.com/api/tuike',
	PRE: _protocol_ + '//sucspre.cnsuning.com/api/tuike',
	XGPRE: _protocol_ + '//sucsprexg.cnsuning.com/api/tuike',
	SIT: _protocol_ + '//sucssit.cnsuning.com/api/tuike',
	DEV: _protocol_ + '//sucspre.cnsuning.com/api/tuike'
};

//易购主站四级页地址
const FOURTH_HOST = {
	PRD: 'https://product.suning.com',
	PRE: 'http://productpre.cnsuning.com',
	XGPRE: 'http://productxgpre.cnsuning.com',
	SIT: 'http://productsit.cnsuning.com',
	DEV: 'http://productpre.cnsuning.com',
}

const CMS_HOST = {
	PRD: _protocol_ + '//lib.suning.com/',
	PRE: _protocol_ + '//libpre.cnsuning.com/',
	XGPRE: _protocol_ + '//libprexg.cnsuning.com/',
	SIT: _protocol_ + '//libsit.cnsuning.com/',
	DEV: _protocol_ + '//libpre.cnsuning.com/'
}
//采集
const SA_HOST = {
	PRD: _protocol_ + ' //res.suning.cn/javascript/sn_da/da_opt.js',
	SIT: _protocol_ + '//sitres.suning.cn/javascript/sn_da/da_opt.js',
	XGPRE: _protocol_ + '//resprexg.suning.cn/javascript/sn_da/da_opt.js',
};

module.exports = {
	isSN_ENV,
	AUTH_HOST,
	SUMFS_HOST,
	ADRES_HOST,
	SUMIS_HOST,
	PASSPORT_HOST,
	SUCS_HOST,
	FOURTH_HOST,
	CMS_HOST,
	SA_HOST,
};